import { settingsAtom } from "../atoms";

export function price(
  price: number,
  currency?: {
    code?: string;
    symbol?: string;
  },
) {
  const currencyCode = currency?.code
    ? currency.code
    : settingsAtom.get("general")?.baseCurrency?.code || "USD";

  const currenySymbol = currency?.symbol
    ? currency.symbol
    : settingsAtom.get("general")?.baseCurrency?.symbol || "$";

  if (!price) return "";

  return currenySymbol
    ? `${currenySymbol}${price.toLocaleString()}`
    : `${price.toLocaleString()}${currencyCode}`;
}
